import React from 'react';

interface MicrosoftIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const MicrosoftIcon: React.FC<MicrosoftIconProps> = ({ width = 18, height = 18, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M0 0H8.65793V8.65793H0V0Z" fill="#F8510C" />
      <path d="M9.3418 0H17.9997V8.65793H9.3418V0Z" fill="#7EBA00" />
      <path d="M0 9.34143H8.65793V17.9994H0V9.34143Z" fill="#00A3F4" />
      <path d="M9.3418 9.34143H17.9997V17.9994H9.3418V9.34143Z" fill="#FFBA00" />
      <path
        d="M17.8857 9.45508V17.8857H9.45605V9.45508H17.8857ZM8.54395 9.45508V17.8857H0.114258V9.45508H8.54395ZM17.8857 0.114258V8.54395H9.45605V0.114258H17.8857ZM8.54395 0.114258V8.54395H0.114258V0.114258H8.54395Z"
        stroke="white"
        strokeWidth="0.22784"
      />
    </svg>
  );
};

export default MicrosoftIcon;
